import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { schluessel, useStatus } from "./api/abfragen.ts";
import { sitzungsEreignisse } from "./api/klient.ts";
import { Huelle } from "./huelle/Huelle.tsx";
import { Anmeldung, Einrichtung } from "./seiten/Zugang.tsx";

export function App() {
  const qc = useQueryClient();
  const status = useStatus();

  useEffect(() => {
    const abgemeldet = () => void qc.invalidateQueries({ queryKey: schluessel.status });
    sitzungsEreignisse.addEventListener("abgemeldet", abgemeldet);
    return () => sitzungsEreignisse.removeEventListener("abgemeldet", abgemeldet);
  }, [qc]);

  if (status.isPending) return <div className="laden-voll" aria-busy="true" />;
  if (status.isError) {
    return (
      <div className="meldung meldung-fehler" role="alert" style={{ margin: 24 }}>
        {status.error.message}
      </div>
    );
  }
  if (!status.data.eingerichtet) return <Einrichtung />;
  if (!status.data.konto) return <Anmeldung />;
  return <Huelle konto={status.data.konto} />;
}
